import { Box, Link, Typography } from '@mui/material';
export const AIOOutcomeFooter = () => {
  return (
    <Box
      sx={{
        p: 3,
        zIndex: 1,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            width: '100%',
            textAlign: 'center',
            color: 'black',
            fontSize: 12,
            fontFamily: 'DM Sans',
            fontWeight: '400',
            wordWrap: 'break-word',
          }}
        >
          Questions?
        </Typography>
        <Box sx={{ width: '100%', textAlign: 'center' }}>
          <Typography
            component="span"
            sx={{
              color: 'black',
              fontSize: 12,
              fontFamily: 'DM Sans',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Email us at{' '}
          </Typography>
          <Link
            href="mailto:kixie@support.com"
            sx={{
              color: 'black',
              fontSize: 12,
              fontFamily: 'DM Sans',
              fontWeight: '600',
              textDecoration: 'underline',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            kixie@support.com
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
